import BaseComponentController from "./base_component_controller"
import { toggle } from "../../../../design_system/transitions"

export default class extends BaseComponentController {
  toggle(event) {
    event?.preventDefault()
    toggle(this.element)
  }
}

